import React from 'react';

import style from './style.module.scss';

export default function Search({onChange,value,...props}){

	return <div {...props} className={style.root} style={{marginTop: 0, marginBottom: 30}}>
		<img src={require('./busca.svg')} alt="" />
		<input
			type="text"
			value={value}
			onChange={onChange}
			placeholder="Buscar Bot"
		/>
	</div>
}
